import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemText } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddUserModal from '../AddUser/AddUserModal';
import { useTheme } from '@mui/material/styles'; // Uvezi useTheme
import './sidebar.css';

const Sidebar = ({ drawerWidth, appBarHeight, isOpen, toggleSidebar }) => {
  const { t } = useTranslation('global');
  const location = useLocation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const theme = useTheme(); // Uzimanje teme

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <Drawer
        variant="persistent"
        anchor="left"
        open={isOpen}
        onClose={toggleSidebar}
        sx={{
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            top: `${appBarHeight}px`,
          },
        }}
      >
        <List>
          <ListItem
            className={location.pathname === '/users' ? 'sidebarElement active' : 'sidebarElement'}
            button
            onClick={() => navigate('/users')}
            sx={{ color: location.pathname === '/users' ? theme.palette.primary.main : 'inherit' }} // Primena glavne boje
          >
            <ListItemText primary={t('sidebar.users')} />
          </ListItem>
          <ListItem
            className={location.pathname === '/add-user' ? 'sidebarElement active' : 'sidebarElement'}
            button
            onClick={handleOpenModal}
            sx={{ color: location.pathname === '/add-user' ? theme.palette.primary.main : 'inherit' }} // Primena glavne boje
          >
            <ListItemText primary={t('sidebar.addANewUser')} />
          </ListItem>
          <ListItem
            className={location.pathname === '/report' ? 'sidebarElement active' : 'sidebarElement'}
            button
            onClick={() => navigate('/report')}
            sx={{ color: location.pathname === '/report' ? theme.palette.primary.main : 'inherit' }} // Primena glavne boje
          >
            <ListItemText primary={t('sidebar.report')} />
          </ListItem>
          <ListItem
            className={location.pathname === '/addEmployee' ? 'sidebarElement active' : 'sidebarElement'}
            button
            onClick={() => navigate('/addEmployee')}
            sx={{ color: location.pathname === '/addEmployee' ? theme.palette.primary.main : 'inherit' }} // Primena glavne boje
          >
            <ListItemText primary={t('sidebar.addEmployee')} />
          </ListItem>
          <ListItem
            className={location.pathname === '/orgUnits' ? 'sidebarElement active' : 'sidebarElement'}
            button
            onClick={() => navigate('/orgUnits')}
            sx={{ color: location.pathname === '/orgUnits' ? theme.palette.primary.main : 'inherit' }} // Primena glavne boje
          >
            <ListItemText primary={t('sidebar.orgUnits')} />
          </ListItem>

          <ListItem
            className={location.pathname === '/employees' ? 'sidebarElement active' : 'sidebarElement'}
            button
            onClick={() => navigate('/employees')}
            sx={{ color: location.pathname === '/employees' ? theme.palette.primary.main : 'inherit' }} // Primena glavne boje
          >
            <ListItemText primary={t('sidebar.employees')} />
          </ListItem>
        </List>
      </Drawer>

      {/* AddUserModal Component */}
      <AddUserModal open={isModalOpen} handleClose={handleCloseModal} />
    </>
  );
};

export default Sidebar;
